import { render, staticRenderFns } from "./KohlerUpgradeButton.vue?vue&type=template&id=73aded03&scoped=true&"
import script from "./KohlerUpgradeButton.vue?vue&type=script&lang=js&"
export * from "./KohlerUpgradeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73aded03",
  null
  
)

export default component.exports